var header = $(".header-expanded");

// if website is scrolled, collapse header
function collapseheader() {
  if ( $( window ).scrollTop() > 1 ) {
    header.removeClass('header-expanded').addClass("header-collapsed");
  }
  else {
    header.removeClass("header-collapsed").addClass('header-expanded');
  }
}
$( window ).scroll( collapseheader );
$( collapseheader );